import { deleteObject } from "firebase/storage";
import { getFileRef } from "../../../firebase/documents/documents";

const deletePreviousPicture = async (path) => {
  await deleteObject(getFileRef(path))
}

export default deletePreviousPicture;